// Fisher-Yates shuffle algorithm
const shuffle = (arr) => {
  let endI = arr.length - 1;

  while (endI) {
    let randI = Math.floor(Math.random() * endI);
    // eslint-disable-next-line no-param-reassign
    [arr[endI], arr[randI]] = [arr[randI], arr[endI]];
    endI -= 1;
  }

  return arr;
};

export const getRandomElements = (list, items = 3) => shuffle([...list]).slice(0, items);
